import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Plus, Clock } from 'lucide-react';

const MEAL_TIME_ICONS = ['🍽️', '🥤', '🍰', '🥗', '🍜', '🥪', '🍕', '☕'];

export function AddMealTimeModal({
  isOpen,
  onClose,
  onAdd,
}) {
  const [name, setName] = useState('');
  const [selectedIcon, setSelectedIcon] = useState('🍽️');

  const handleAdd = () => {
    if (!name.trim()) return;
    
    onAdd({
      id: `custom_${Date.now()}`,
      name: name.trim(),
      icon: selectedIcon,
      isCustom: true,
    });
    
    setName('');
    setSelectedIcon('🍽️');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-900 border-slate-800 text-white max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <Clock className="h-5 w-5 text-purple-400" />
            Add Custom Meal Time
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Name Input */}
          <div className="space-y-2">
            <Label className="text-white">Meal Name</Label>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Pre-workout, Late night snack"
              className="bg-slate-800 border-slate-700 text-white"
              autoFocus
            />
          </div>

          {/* Icon Selector */}
          <div className="space-y-2">
            <Label className="text-white">Icon</Label>
            <div className="flex flex-wrap gap-2">
              {MEAL_TIME_ICONS.map(icon => (
                <button
                  key={icon}
                  onClick={() => setSelectedIcon(icon)}
                  className={`w-10 h-10 rounded-lg text-xl flex items-center justify-center transition-colors ${
                    selectedIcon === icon
                      ? 'bg-purple-500 ring-2 ring-purple-400'
                      : 'bg-slate-800 hover:bg-slate-700'
                  }`}
                >
                  {icon}
                </button>
              ))}
            </div>
          </div>

          {/* Preview */}
          <div className="p-3 bg-slate-800 rounded-lg">
            <p className="text-slate-400 text-sm mb-1">Preview:</p>
            <p className="text-white">
              {selectedIcon} {name || 'Custom Meal'}
            </p>
          </div>

          {/* Add Button */}
          <Button
            onClick={handleAdd}
            disabled={!name.trim()}
            className="w-full bg-purple-600 hover:bg-purple-500"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Meal Time
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default AddMealTimeModal;
